export const getsinglereq="getsinglereq"
export const getsinglesucc="getsinglesucc"
export const getsinglefail="getsinglefail"
